import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from 'config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Link,
  LinkIcon
} from '../../components'
import Styles from './Issues.css'

@CSSModules(Styles, {allowMultiple:true})
export default class Issues extends Component {
  constructor(props) {
    super(props)
    this.state = {
      title: 'The issues',
      description: 'We rate retirement plans and mutual funds on environmental and social sustainability issues.',
      url: config.domain + config.routes.issues
    }
  }

  render() {
    const descriptions = {
      'Fossil fuels': 'Coal, oil, and gas release carbon pollution that accelerates the climate emergency.',
      'Fossil fuel finance & insurance': 'Banks and insurers are financing and underwriting fossil fuels - including tar sands, arctic drilling, and coal mining.',
      'Deforestation': 'Clearing rain forests for cattle grazing or palm oil production contributes to the climate crisis and threatens the rights of Indigenous peoples.',
      'Gender equality': 'Collecting data and scoring companies on gender equality is the first step towards sustainable change.',
      'Civilian firearms': 'Retirement plans are investing in firearm manufacturers and retailers raking in billions in handgun, assault rifle, and ammunition sales.',
      'Prison industrial complex': 'Investor-owned companies are profiting from exploitative prison labor, immigration jails, and other economic systems of oppression and exploitation.',
      'Arms manufacturers': 'Through the global weapons trade, some arms manufacturers supply military goods to states at risk of using weapons for oppression or aggression.',
      'Tobacco': 'Smoking is a leading cause of preventable death. Most smokers start before they’re 18. Every day, more than 2,000 young Americans become daily smokers.',
    }
    //
    return (
      <div styleName='page'>
        {
          container.helmet(
            this.state.title,
            this.state.description,
            this.state.url
          )
        }
        <ContainerDivs>
          <h1 styleName='large-page-title'>
            {this.state.title}
          </h1>
          <div styleName='content'>
            <h2>We rate retirement plans and mutual funds on environmental and social sustainability issues.</h2>
            <nav styleName='nav-flex'>
              {
                [
                  [config.routes.issueFossilFuels, 'Fossil fuels', 'fossil-fuels'],
                  [config.routes.issueFossilFuelFinanceInsurance, 'Fossil fuel finance & insurance', 'fossil-fuel-finance-insurance'],
                  [config.routes.issueDeforestation, 'Deforestation', 'deforestation'],
                  [config.routes.issueGenderEquality, 'Gender equality', 'gender-equality'],
                  [config.routes.issueCivilianFirearms, 'Civilian firearms', 'civilian-firearms'],
                  [config.routes.issuePrisonIndustrialComplex, 'Prison industrial complex', 'prison-industrial-complex'],
                  [config.routes.issueArmsManufacturers, 'Arms manufacturers', 'arms-manufacturers'],
                  [config.routes.issueTobacco, 'Tobacco', 'tobacco'],
                ].map((e, i) => {
                  const [url, title, imgName] = e
                  const description = descriptions[title] || 'Lorem'
                  return (
                    <div styleName='issue-link'>
                      <Link
                        to={url}
                        title={'Issue: ' + title}
                      >
                        <div styleName={'img-'+imgName}/>
                        <h3>
                          {title}
                        </h3>
                        <p>
                          {description}
                        </p>
                        <p>
                          Learn more<LinkIcon />
                        </p>
                      </Link>
                    </div>
                  )
                })
              }
            </nav>
          </div>
        </ContainerDivs>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
      </div>
    )
  }
}